const accepted = 'accepted';
const expired = 'expired';
const notAccepted = 'not_accepted';

/**
 * Класс для работы со статусами
 */
export class InviteStatusesService {
    /**
     * Метод возвращает статус инвайта.
     *
     * @param status Статус инвайта.
     *
     * @returns {string}
     */
    getStatus(status) {

        if (status === accepted) {
            return { 
                title: 'Приглашение принято',
                color: 'green'
            };
        }

        if (status === expired) {
            return { 
                title: 'Время приглашения истекло',
                color: 'red'
            };
        }

        if (status === notAccepted) {
            return { 
                title: 'Ожидает приема',
                color: 'orange'
            };
        }
    }
}